$.extend(true, BT, {
	initProductThumbsSlider: function(wrap) {
    const options = this.options.productGroup, selector = this.selectors.productGroup;
    if(wrap.find(selector.thumbsSlider).length > 0) {
      this.loadCssJsLib('slider', () => {
        wrap.find(selector.thumbsSlider).each((index, thumbSliderEle) => {
          let optionsSlider = {};
          const thumbSlider = $(thumbSliderEle);
          $.extend(true, optionsSlider, options.smallSlider);
          if(thumbSlider.hasClass(selector.thumbsSliderVerticalClass)) {
            optionsSlider.vertical = true; 
            optionsSlider.verticalSwiping = true;
            optionsSlider.nextArrow = options.smallVerticalArrows.next;
            optionsSlider.prevArrow = options.smallVerticalArrows.prev; 
          } else if(thumbSlider.hasClass('pg__thumbs--small')) {
            optionsSlider.slidesToShow = 10;
          }
          this.preInitSlider(thumbSlider, true);
          thumbSlider.slick(optionsSlider);
        });
      });
    }
  },

  destroyProductThumbsSlider: function(wrap) {
    const selector = this.selectors.productGroup;
    if(wrap.find(selector.thumbsSlider).length > 0) {
      wrap.find(selector.thumbsSlider).each((index, thumbSliderEle) => {
        $(thumbSliderEle).slick('unslick');
      });
    }
  },

  pauseCurrentProductVideo: function(pg) {
    if(this.data.productVideo.currentPlayer != null) {
      pg.find(this.selectors.mediaBtn).removeClass('hide');
      var currentVideoType = this.data.productVideo.currentType;
      if(currentVideoType == 'youtube' && this.data.productVideo.loadYoutubeApi) {
        this.data.productVideo.currentPlayer.pauseVideo();
        $('#' + this.data.productVideo.currentYoutubePlayerId).parents('.youtube-wrapper').addClass('hide');
      } else if(currentVideoType == 'vimeo' && this.data.productVideo.loadVimeoApi) {
        this.data.productVideo.currentPlayer.pause();
        $('#' + this.data.productVideo.currentVimeoPlayerId).parents('.vimeo-wrapper').addClass('hide');
      } else {
        this.data.productVideo.currentPlayer.pause();
      }
      this.data.productVideo.currentPlayer = null;
      this.data.productVideo.currentType = null;
    }
  },

  playProductVideo: function(pg, ele) {
    var selector = this.selectors.productGroup;
    var videoEle = ele.find(selector.video);
    if(videoEle.length > 0) {
      pg.find(this.selectors.mediaBtn).addClass('hide');
      if(videoEle.hasClass(selector.videoYoutube.replace('.',''))) {
        this.loadCssJsLib("youtube", function(){
          if(this.data.productVideo.loadYoutubeApi) {
            this.initYoutubePlayer(videoEle);
          } else {
            var checkYT = setInterval(function () {
              if(YT.loaded){
                clearInterval(checkYT);
                this.data.productVideo.loadYoutubeApi = true;
                this.initYoutubePlayer(videoEle);
              }
            }.bind(this), 100);
          }
        }.bind(this));
      } else if(videoEle.hasClass(selector.videoVimeo.replace('.',''))) {
        this.loadCssJsLib("vimeo", function(){
          this.data.productVideo.loadVimeoApi = true;
          this.initVimeoPlayer(videoEle);
        }.bind(this));
      } else {
        this.data.productVideo.currentType = 'custom';
        this.data.productVideo.currentPlayer = videoEle.get(0);
        this.data.productVideo.currentPlayer.play();
      }
    }
  },

  initYoutubePlayer: function(videoEle) {
    var playerId = videoEle.attr('data-player-id');
    var videoId = videoEle.attr('data-video-id');
    var playerEle = $('#' + playerId);
    playerEle.parents('.youtube-wrapper').removeClass('hide');
    videoEle.css('opacity',0);
    this.data.productVideo.currentYoutubePlayerId = playerId;
    this.data.productVideo.currentType = 'youtube';
    if(playerEle.hasClass('loaded')) {
      YT.get(playerId).playVideo();
    } else {
      playerEle.addClass('loaded');
      new YT.Player(playerId, {
        height: '480',
        width: '100%',
        playerVars :{
          autohide: 0,
          autoplay: 1,
          branding: 0,
          cc_load_policy: 0,
          controls: 1,
          fs: 1,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 0,
          quality: 'hd720',
          rel: 0,
          showinfo: 0,
          wmode: 'opaque',
          loop: 1,
          playlist: videoId
        },
        videoId: videoId,
        events: {
          'onReady': function(event) {
            event.target.mute();
            event.target.playVideo();
          }
        }
      });
    }
    this.data.productVideo.currentPlayer = YT.get(playerId);
  },

  initVimeoPlayer: function(videoEle) {
    var iframe = $('#' + videoEle.attr('data-player-id'));
    var id = iframe.attr('id');
    iframe.parents('.vimeo-wrapper').removeClass('hide');
    this.data.productVideo.currentType = 'vimeo';
    this.data.productVideo.currentVimeoPlayerId = id;
    if(this.data.productVideo.vimeoPlayers[id] == undefined) {
      // vimeoPlayers[id] = new Vimeo.Player(iframe);
      iframe.removeClass('hide');
      var player = new Vimeo.Player(iframe.get(0), {width: 800});
      player.setVolume(0);
      player.play();
      this.data.productVideo.currentPlayer = player;
    } else {
      this.data.productVideo.currentPlayer = this.data.productVideo.vimeoPlayers[id];
      this.data.productVideo.currentPlayer.play();
    }
  },

  play3dModel: function(modelViewContainer) {
    if(!modelViewContainer.hasClass('loaded')) {
      modelViewContainer.trigger('mediaVisible');
      modelViewContainer.addClass('loaded');
    }
  },

  init3dModel: function(container, sectionId) {
    var $modelViewerElements = $(
      '[data-product-media-type-model]',
      container
    );
    if ($modelViewerElements.length < 1) return;
    theme.ProductModel.init($modelViewerElements, sectionId);
  },

  initProductMainSliderAndZoom: function(wrap, timeoutMobile, timeoutDesktop) {
    const options = this.options.productGroup;
    const selector = this.selectors.productGroup;
    if(wrap.find(selector.mainsSlider).length > 0) {
      var timeout = this.data.cacheWindowWidth < 768 ? timeoutMobile : timeoutDesktop;
      setTimeout(() => {
        this.loadCssJsLib('slider', () => {
          wrap.find(selector.mainsSlider).each((index, mainSliderEle) => {
            var optionsSlider = {};
            const mainSlider = $(mainSliderEle);
            $.extend(true, optionsSlider, options.mainSlider);
            this.preInitSlider(mainSlider, true);
              // code to execute after animation ends
            const slider = mainSlider.slick(optionsSlider);
            const pg = mainSlider.parents(selector.wrap);
            this.playProductVideo(pg, slider.find('.slick-current'));
            this.initProductMainZoom(pg);
            slider.on('afterChange', (event, slick, currentSlide, nextSlide) => {
              var mainLink = slick.$slider.find('.slick-current ' + selector.mainLink);
              if(pg.find(selector.thumbs).length > 0) {
                var thumbs = pg.find(selector.thumbs);
                var thumbLink = thumbs.find(selector.thumb + ':not(slick-clone) ' + selector.thumbLink + '[data-image-id="' + mainLink.attr('data-image-id') + '"]');
                thumbLink.parent().addClass('active').siblings('.active').removeClass('active');
                if(thumbs.hasClass('slick-initialized')) {
                  this.gotoSliderIndex(thumbs, thumbLink.parent().attr('data-slick-index'), false);
                }
              }
              this.pauseCurrentProductVideo(pg);
              this.playProductVideo(pg, slick.$slider.find('.slick-current'));
              setTimeout(() => {
                if(mainLink.hasClass(selector.mainLinkModel.replace('.',''))) {
                  this.play3dModel(mainLink);
                  slider.slick("slickSetOption", "swipe", false, false);
                  slider.addClass('play-model');
                } else if(slider.hasClass('play-model')) {
                  slider.slick("slickSetOption", "swipe", true, false);
                  slider.removeClass('play-model');
                }
                if(mainLink.hasClass(selector.ignoreLightBoxClass)) {
                  slider.addClass('no-light-box-icon');
                } else {
                  slider.removeClass('no-light-box-icon');
                }
              }, 300);
            });
          });
        });
      }, timeout);
    } else {
      this.initProductMainZoom(wrap);
    }
  },

  destroyProductMainSliderAndZoom: function(wrap) {
    const selector = this.selectors.productGroup;
    if(wrap.find(selector.mainsSlider).length > 0) {
      wrap.find(selector.mainsSlider).each((index, mainSlider) => {
        $(mainSlider).slick('unslick');
        var pg = $(mainSlider).parents(selector.wrap);
        this.destroyProductMainZoom(pg);
      });
    }
  },

  initProductMainZoom: function(pg) {
    if(this.data.cacheWindowWidth < 1200) {
      return;
    }
    const selector = this.selectors.productGroup;
    const currentSize = pg.find(selector.mainLinkZoom).length;
    if(currentSize > 0) {
      new Promise((resolve, reject) => {
        this.loadCssJsLib("zoom", resolve);
      }).then(() => {
        pg.find(selector.mainLinkZoom).each((index, mainLinkEle) => {
          let mainLink = $(mainLinkEle);
          setTimeout(() => {
            mainLink.trigger('zoom.destroy');
            mainLink.zoom({url: mainLink.attr('href')});
            $(window).on(this.data.resizeEventName, () => {
              if(this.data.cacheWindowWidth >= 1200 ) {
                mainLink.zoom({url: mainLink.attr('href')});
              } else {
                mainLink.trigger('zoom.destroy');
              }
            });
          }, 1000);  
        });
      }, (err) => {
        // console.log(err);
      });
    }
  },

  destroyProductMainZoom: function(pg) {
    if(this.data.cacheWindowWidth < 1200) {
      return;
    }
    const selector = this.selectors.productGroup;
    const currentSize = pg.find(selector.mainLinkZoom).length;
    if(currentSize > 0) {
      pg.find(selector.mainLinkZoom).each((index, mainLinkEle) => {
        $(mainLinkEle).trigger('zoom.destroy');
      });
    }
  },

  createSrcset50WImg: function(orgSrc) {
    var sizes = [90,180,270,360,415,540,648,756,860,972,1080,1188,2592,1404,1512];
    var length = sizes.length;
    var result = [];
    for(var i = 0; i < length; i++) {
      var size = sizes[i] + 'x';
      result.push(this.newResizeImage(orgSrc, size) + ' ' + sizes[i] + 'w');
    }
    return result.join(',');
  },

  changeMainImage: function(pg, orgSrc) {
    const selector = this.selectors.productGroup;
    pg.find(selector.mainImg).each((index, ele) => {
      $(ele).attr('srcset', this.createSrcset50WImg(orgSrc));
    });
  },

  updateMainThumbnail: function(pg, orgSrc, imageId) {
    const selector = this.selectors.productGroup;
    const mains = pg.find(selector.mains);
    let index;
    if(mains.length > 0) { // View on product page or quick view
      var mainLink;
      const thumbLink = pg.find(selector.thumbLink + '[data-image-id="' + imageId + '"]');
      if(imageId != undefined) {
        mainLink = pg.find(selector.mainLink + '[data-image-id="' + imageId + '"]');
      } else {
        mainLink = pg.find(selector.mainLink + '[data-image-id="' + thumbLink.attr('data-image-id') + '"]');
      }
      if(mains.hasClass(selector.mainsSlider.replace('.',''))) { // Mains images is a slider
        index = mainLink.parents('.slick-slide').first().attr('data-slick-index');
        mains.addClass('ignore-trigger');
        this.gotoSliderIndex(mains, index);
      } else if(thumbLink == null || thumbLink.length == 0) {
        if(orgSrc == null) {
          return;
        }
        this.changeMainImage(pg, orgSrc);
      } else {
        this.changeMainImage(pg, thumbLink.attr('href'));
      }      
    } else {
      if(orgSrc == null) {
        return;
      }
      this.changeMainImage(pg, orgSrc);
    }
  },
  
  updateStorePickup: function(pg, variant) {
    if(variant != undefined) {
      const selector = this.selectors.productGroup;
      const storePickupWrap = pg.find(selector.storePickupWrap);
      if(storePickupWrap.length > 0) {
        if(!variant.available) {
          storePickupWrap.addClass('hide');
        } else {
          storePickupWrap.addClass('loading-store-data');
          const url = theme.rootUrl + 'variants/' + variant.id;
          this.callAjax(url, 'get', {section_id: 'store-availability'}, null, (response) => {
            var information = $('.store-availability-information', response);
            if(information.length > 0) {
              storePickupWrap.find(selector.storePickupInner).html(information[0].outerHTML);
              $('body').find(selector.storePickupModel).remove();
              $('body').append($(selector.storePickupModel, response));
              $(selector.storePickupProductTitle).text(pg.find('.product-single__title').text());
              if(storePickupWrap.hasClass('hide-default-title')) {
                $(selector.storePickupVariantTitle).hide();
              }
              storePickupWrap.removeClass('hide');
            } else {
              storePickupWrap.addClass('hide');
            }
            storePickupWrap.removeClass('loading-store-data');
          });
        }
      }
    }
  },

  updateNewVariant: function(pg, newVariant, isUpdateMain) {
    const selector = this.selectors.productGroup;
    // Update cart button
    this.updateCartBtn(pg, newVariant);
    
    if(newVariant.available) {
      pg.find(selector.stockText).text(theme.strings.instockText).removeClass('soldout');
    } else {
      pg.find(selector.stockText).text(theme.strings.soldOut).addClass('soldout');
    }

    // Update main image
    if(isUpdateMain) {
      this.updateMainThumbnail(pg, newVariant.featured_media.src, newVariant.featured_media.id);
    }

    // Update price
    pg.find(selector.price).html(this.getVariantPriceHtml(pg, newVariant));
    
    this.convertCurrencySilence(pg.find('span.money'));

    this.updateStorePickup(pg, newVariant);

    pg.find(selector.variantId).val(newVariant.id);
    pg.find(selector.variantId).trigger('change');
    if(pg.find(selector.variantTitle).length > 0) {
      pg.find(selector.variantTitle).text(newVariant.title);
    }
    
    // Update history
    if(pg.attr('data-history') != undefined) {
      var hrefParts = window.location.href.split('?');
      var newUrl = hrefParts[0] + '?';
      if(hrefParts.length > 1 && hrefParts[1]) {
        if(hrefParts[1].indexOf('variant') > -1) {
          newUrl += hrefParts[1].replace(/(variant=).*?(&|$)/,'$1' + newVariant.id + '$2');
        } else {
          newUrl += hrefParts[1] + '&variant=' + newVariant.id;
        }
      } else {
        newUrl += 'variant=' + newVariant.id;
      }
      // var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + newVariant.id;
      window.history.replaceState({path: newUrl}, '', newUrl);  
    }

    // Update deal label
    this.updateDealLabel(pg, newVariant.price, newVariant.compare_at_price);

    const progress = pg.find(selector.singleProgress);
    if(progress.length > 0) {
      if(newVariant.available) {
      var finalQuantityNumber;
      if(progress.attr('data-min') != undefined && progress.attr('data-max') != undefined) {
        finalQuantityNumber = this.getRandomIntInclusive(parseInt(progress.attr('data-min')), parseInt(progress.attr('data-max')));
      } else {
        finalQuantityNumber = newVariant.inventory_quantity;
      }
      threshold = parseInt(progress.attr('data-threshold'));
      if(finalQuantityNumber > threshold) {
        progress.addClass('hide');
      } else {
        progress.removeClass('hide');
        var bar = progress.find('.progress-bar');
        if(finalQuantityNumber > 0) {
          progress.find(selector.stockText1).removeClass('hide');
          progress.find(selector.stockText2).addClass('hide');
          bar.css('width', bar.attr('aria-valuenow') + '%');
        } else {
          progress.find(selector.stockText2).removeClass('hide');
          progress.find(selector.stockText1).addClass('hide');
          bar.css('width', '99%');
        }
        progress.find(selector.stockNumber).text(newVariant.inventory_quantity);
        }
      } else {
        progress.addClass('hide');
      }
    }

    // Sync the variant
    this.syncVariantUrl(pg, newVariant);

    // Update SKU
    var skuTag = pg.find(selector.sku);
    if(skuTag.length > 0) {
      if(newVariant.sku) {
        skuTag.text(newVariant.sku);
        skuTag.parent().removeClass('hide');
      } else {
        skuTag.parent().addClass('hide');
      }
    }   
  },
  getRandomIntInclusive: function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  },

  initMainLightboxGallery: function() {
    const selector = this.selectors.productGroup;
    $(document).on('click', selector.mainLink, (e) => {
      if(!$(e.currentTarget).hasClass(selector.ignoreLightBoxClass)) {
        e.preventDefault();
        var mediaBtn = $(e.currentTarget).siblings(this.selectors.mediaBtn);
        if(mediaBtn.length > 0) {
          mediaBtn.trigger('click',[$(e.currentTarget).attr('data-image-id')])
        } else {
          $(e.currentTarget).parents(selector.wrap).find(this.selectors.mediaBtn).trigger('click',[$(e.currentTarget).attr('data-image-id')]);  
        }
      }
    });
  },

  openLightboxByPhotoswipe: function(pg, currentImageId) {
    const selector = this.selectors.productGroup;
    if(pg.find(selector.mainLink).length > 0) {
      var items = [];
      var activeIndex = 0;
      var indexImage = 0;
      pg.find(selector.mainLink + ':not(.hide)').each((index, element) => {
        if($(element).hasClass(selector.ignoreLightBoxClass)) {
          return;
        }
        const ele = $(element);
        var title = ele.attr('title');
        if(title) {
          title = title.replace(/ group-(.*?) /g, ' ').replace(/group-(.*?) /g, '').split('group')[0];
        }
        if(currentImageId != undefined) {
          if(ele.attr('data-image-id') == currentImageId) {
            activeIndex = indexImage;
          }
        } else if(ele.parent().hasClass('active')) {
          activeIndex = indexImage;
        }
        items.push({
          src: ele.attr('href'),
          w: ele.attr('data-width'),
          h: ele.attr('data-height'),
          msrc: this.resizeImage(ele.attr('href'), '96x'),
          title: title,
          el: ele.parent()[0]
        });
        indexImage++;
      });
      var pswpElement = document.querySelectorAll('.pswp')[0];
      // define options (if needed)
      var options = {
          // optionName: 'option value'
          // for example:
          index: activeIndex, // start at first slide,
          getThumbBoundsFn: function(index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect(); 

            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          },
          shareButtons: []
      };
      var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    }
  },

  openLightboxByLightGallery: function(pg, currentImageId) {
    var selector = this.selectors.productGroup;
    if(pg.find(selector.mainLink).length > 0) {
      var data = [];
      var activeIndex = 0;
      var indexImage = 0;
      pg.find(selector.mainLink + ':not(.hide)').each((index, element) => {
        if($(element).hasClass(selector.ignoreLightBoxClass)) {
          return;
        }
        const ele = $(element);
        var title = ele.attr('title');
        if(title) {
          title = title.replace(/ group-(.*?) /g, ' ').replace(/group-(.*?) /g, '').split('group')[0];
        }
        if(currentImageId != undefined) {
          if(ele.attr('data-image-id') == currentImageId) {
            activeIndex = indexImage;
          }
        } else if(ele.parent().hasClass('active')) {
          activeIndex = indexImage;
        }
        data.push({
          src: ele.attr('href'),
          thumb: this.resizeImage(ele.attr('href'), '96x'),
          subHtml: title
        });
        indexImage++;
      });
      if(rtl) {
        data.reverse();
        activeIndex = indexImage - activeIndex - 1;
      }
      if(pg.data('lightGallery')) {
        pg.off('onCloseAfter.lg');
      }
      pg.lightGallery({
        dynamic: true,
        dynamicEl: data,
        index: activeIndex,
        download: false
      });
      pg.on('onCloseAfter.lg', (event) => {
        setTimeout(() => {
          if(typeof pg.data('lightGallery') != 'undefined') {
            pg.data('lightGallery').destroy(true);
          }
        }, 300);
      });
    }
  },

  initMediaButton: function() {
    const selector = this.selectors.productGroup;
    let working = false;
    $(document).on('click', this.selectors.mediaBtn, (e, currentImageId) => {
      e.preventDefault();
      if(working) {
        return;
      }
      const btn = $(e.currentTarget);
      const pg = btn.parents(selector.wrap);
      if(currentImageId == undefined) {
        if(btn.attr('data-media-id') != undefined) {
          currentImageId = btn.attr('data-media-id');  
        } else {
          currentImageId = pg.find(selector.mainsSlider + ' .slick-current ' + selector.mainLink).attr('data-image-id');
        }
      }
      working = true;
      
      this.startLoadingBtn(btn);
      this.showLoadingFull();
      if(BT.data.cacheWindowWidth < 1200) {
        this.loadSnippetAjax('photoswipe', () => {
          this.loadCssJsLib('photoswipe', () => {
            setTimeout(() => {
              this.endLoadingBtn(btn);
              this.hideLoadingFull();
              this.openLightboxByPhotoswipe(pg, currentImageId);
              working = false;
            }, 400);
          });
        }, 300);
      } else {
        this.loadCssJsLib('lightgallery', () => {
          this.endLoadingBtn(btn);
          this.hideLoadingFull();
          this.openLightboxByLightGallery(pg, currentImageId);
          working = false;
        });
      }
    });
  },

  initProductGlobal: function() {
    this.initMediaButton();
    this.initMainLightboxGallery();
    // Init click event for product thumbs
    const selector = this.selectors.productGroup;
    $(document).on('click', selector.thumbLink, (e, fromMainSlider) => {
      e.preventDefault();
      if($(e.currentTarget).parent().hasClass('active')) {
        return;
      }
      const currentThumbLink = $(e.currentTarget);
      const pg = currentThumbLink.parents(selector.wrap);
      this.updateMainThumbnail(pg, null, currentThumbLink.attr('data-image-id'));
    });
  }
});
BT.initProductGlobal();
theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.mediaGroup)
          .find(selectors.xrButton);
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    BT.loadCssJsLib('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);
        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (BT.data.isTouchDevide) return;
      model.modelViewerUi.play();
    });

    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();